module.exports = __webpack_public_path__ + "static/img/zasilacz.b10f6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/zasilacz.png
// module id = f2+t
// module chunks = 1